import React from 'react'

const WhyChooseUs = () => {

  
  const reasons = [
  {
    title: "Ergebnisorientiertes Webdesign",
    image: "/images/design-impact.png",
    description: "Wir kreieren nicht nur schöne Webseiten, sondern digitale Werkzeuge, die Ihre Geschäftsziele messbar unterstützen und Ihre Marke stärken."
  },
  {
    title: "Gezielte Konversionsoptimierung",
    image: "/images/conversion.png",
    description: "Durch strategische Verkaufspsychologie und klare Handlungsaufforderungen verwandeln wir Ihre Webseiten-Besucher effizient in zahlende Kunden."
  },
  {
    title: "Nutzerzentrierte Entwicklung",
    image: "/images/user-experience.png",
    description: "Bei uns steht der Mensch im Mittelpunkt. Wir entwickeln intuitive Interfaces, die eine erstklassige Nutzererfahrung auf allen Endgeräten garantieren."
  },
  {
    title: "Maximale Performance & Speed",
    image: "/images/performance.png",
    description: "Schnelle Ladezeiten sind entscheidend. Wir optimieren jede Zeile Code, um sicherzustellen, dass Ihre Seite bei Google und bei Ihren Nutzern punktet."
  },
  {
    title: "Individuelle Full-Service Lösungen",
    description: "Von der ersten Idee bis zur finalen Umsetzung – wir bieten Ihnen maßgeschneiderte Strategien, die exakt auf Ihre spezifischen Bedürfnisse zugeschnitten sind.",
    image: "/images/full-service.png"
  },
  {
    title: "Transparenz & Partnerschaft",
    image: "/images/support.png",
    description: "Wir arbeiten eng mit Ihnen zusammen. Durch klare Kommunikation und regelmäßige Updates sind Sie immer über den Fortschritt Ihres Projekts informiert."
  }
];
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Éléments décoratifs en arrière-plan */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-0">
        
        {/* En-tête de section */}
        <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
          <h2 className="text-primary font-bold tracking-widest uppercase text-sm">Vorteile</h2>
          <h3 className="text-4xl md:text-5xl font-black text-secondary leading-tight">
            Warum sollten Sie sich für uns entscheiden?
          </h3>
          <div className="w-24 h-1.5 bg-primary mx-auto rounded-full"></div>
        </div>

        {/* Grille de Raisons */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((item, index) => (
            <div 
              key={index}
              className="group relative bg-white border border-slate-100 p-8 rounded-[2.5rem] transition-all duration-500 hover:shadow-2xl hover:shadow-primary/10 hover:-translate-y-2 overflow-hidden"
            >
              {/* Effet de gradient au survol sur le coin de la carte */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-bl-full translate-x-16 -translate-y-16 group-hover:translate-x-8 group-hover:-translate-y-8 transition-transform duration-500"></div>

              {/* Conteneur d'image/icône */}
              <div className="relative mb-8">
                <div className="w-20 h-20 bg-slate-50 rounded-2xl flex items-center justify-center group-hover:bg-primary/10 transition-colors duration-500">
                  <img 
                    src={item.image} 
                    alt={item.title} 
                    className="w-12 h-12 object-contain group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              </div>

              {/* Contenu Texte */}
              <div className="space-y-4">
                <h4 className="text-xl font-bold text-secondary group-hover:text-primary transition-colors duration-300">
                  {item.title}
                </h4>
                <p className="text-slate-500 leading-relaxed group-hover:text-slate-700 transition-colors duration-300">
                  {item.description}
                </p>
              </div>

              {/* Barre de progression décorative en bas */}
              <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-primary to-secondary w-0 group-hover:w-full transition-all duration-700"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUs